const features = [
  {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" />
      </svg>
    ),
    text: 'Parking facile et sécurisé au World Trade Center.',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" />
      </svg>
    ),
    text: 'Espace modulable adapté aux poussettes et aux enfants.',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" />
      </svg>
    ),
    text: 'Service traiteur haut de gamme par les équipes Pullman.',
  },
];

export default function VenueSection() {
  return (
    <section id="lieu" className="py-24 lg:py-32 bg-blush relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-cream-warm to-transparent opacity-50 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image side */}
          <div className="relative order-2 lg:order-1">
            {/* Main image container */}
            <div className="relative">
              {/* Gold frame accent */}
              <div className="absolute -inset-4 border border-gold/30" />
              <div className="absolute -inset-8 border border-gold/10" />

              {/* Image placeholder with venue branding */}
              <div className="relative bg-gradient-to-br from-navy-800 to-navy-900 aspect-[4/3] flex items-center justify-center overflow-hidden">
                {/* Subtle pattern */}
                <div
                  className="absolute inset-0 opacity-5 pointer-events-none"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23C9A227' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M0 20L20 0v20H0zm20 0L40 0v20H20zm0 0v20l20-20H20zm0 0H0l20 20V20z'/%3E%3C/g%3E%3C/svg%3E")`,
                  }}
                />

                <div className="relative text-center p-8">
                  <div className="flex items-center justify-center gap-8 mb-6">
                    <img
                      src="/pullman-logo.png"
                      alt="Pullman Bucharest World Trade Center"
                      className="h-24 w-auto brightness-0 invert"
                    />
                    <span className="text-gold/40 font-light text-3xl">&</span>
                    <a
                      href="https://lagalette.ro/en/homepage/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:opacity-80 transition-opacity"
                    >
                      <img
                        src="/la-galette-logo.png"
                        alt="La Galette"
                        className="h-14 w-auto brightness-0 invert"
                      />
                    </a>
                  </div>
                  <div className="h-px w-16 bg-gold/50 mx-auto mb-6" />
                  <p className="font-serif text-2xl text-cream mb-2">Pullman & La Galette</p>
                  <p className="font-body text-sm text-cream/50 uppercase tracking-wider">
                    World Trade Center, Bucharest
                  </p>
                </div>
              </div>
            </div>

            {/* Floating testimonial card */}
            <div className="absolute -bottom-8 -right-4 lg:-right-8 bg-white p-6 shadow-elegant-lg max-w-xs hidden md:block border-l-4 border-gold">
              <p className="font-serif text-navy-700 italic leading-relaxed mb-3">
                "Un cadre chic et cosy, parfait pour nos familles."
              </p>
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-4 h-4 text-gold" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>
          </div>

          {/* Content side */}
          <div className="order-1 lg:order-2">
            <span className="inline-block font-body text-sm text-burgundy uppercase tracking-[0.2em] mb-4">
              Le Lieu
            </span>
            <h2 className="font-serif font-semibold text-4xl md:text-5xl text-navy-900 mb-6 leading-tight">
              Une collaboration
              <span className="block text-gradient-gold">d'exception</span>
            </h2>

            <div className="space-y-6 mb-10">
              <p className="font-body text-lg text-navy-600 leading-relaxed">
                L'UFE Roumanie et le{' '}
                <strong className="font-semibold text-navy-800">Pullman Bucharest World Trade Center</strong> s'associent pour
                vous offrir une Épiphanie mémorable.
              </p>
              <p className="font-body text-navy-600 leading-relaxed">
                Le restaurant <strong className="font-semibold text-navy-800">La Galette</strong> nous ouvre ses portes avec sa
                décoration chaleureuse et sa terrasse d'hiver lumineuse. Plus qu'un
                simple lieu, le Pullman participe activement à l'événement en mettant à
                disposition son savoir-faire pâtissier.
              </p>
            </div>

            {/* Features list */}
            <ul className="space-y-4 mb-10">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start gap-4 group">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gold/10 text-gold group-hover:bg-gold group-hover:text-navy-900 transition-all duration-300">
                    {feature.icon}
                  </span>
                  <span className="font-body text-navy-700 pt-1">{feature.text}</span>
                </li>
              ))}
            </ul>

            {/* Map link */}
            <a
              href="https://maps.google.com/?q=Pullman+Bucharest+World+Trade+Center"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 font-serif font-medium text-burgundy hover:text-burgundy-dark transition-colors group"
            >
              <span className="w-10 h-10 flex items-center justify-center border border-burgundy/30 group-hover:bg-burgundy group-hover:text-cream group-hover:border-burgundy transition-all duration-300">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </span>
              <span>Voir sur la carte</span>
              <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
